import * as Yup from "yup";

const noSpecialCharactersRegex = /^[A-Za-z0-9 ]*$/;

export const validationSchema = Yup.object().shape({
    agency_name: Yup.string().required("This field is required!"),
    dba_name: Yup.string(),
    agency_npn: Yup.string().required("This field is required!"),
    address1: Yup.string().required("This field is required!"),
    city: Yup.string().required("This field is required!"),
    zip: Yup.string().required("This field is required!"),
    owner_firstName: Yup.string()
      .required("This field is required!")
      .matches(
        noSpecialCharactersRegex,
        "First Name must not contain special characters"
      ),
    owner_lastName: Yup.string()
      .required("This field is required!")
      .matches(
        noSpecialCharactersRegex,
        "Last Name must not contain special characters"
      ),
    owner_email: Yup.string().required("This field is required!"),
    source: Yup.string().required("This field is required!"),
  });
